import {
  Button,
  Card,
  CardContent,
  DialogActions,
  DialogContent,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import DateRangeIcon from "@material-ui/icons/DateRange";
import CustomInput from "components/custom/CustomInput";
import Colors from "shared/color";
import Spin from "components/ui/Spin";

import { toastSuccess, toastWarning } from "shared/utils";

import { verifyDeposit } from "shared/api/deposit";
import { KisstRadio } from "components/ui/KisstRadio";
import { getOperatingBankAccounts } from "shared/api";
import MNativeSelect from "../../../components/ui/MNativeSelect";
import { connect } from "react-redux";
import { format } from "date-fns";
import { TextareaAutosize } from '@material-ui/core';

const TCell = (props) => {
  return (
    <TableCell
      style={{
        border: "none",
        fontSize: "0.8125rem",
        padding: " 3px",
        ...props.style,
      }}
    >
      {props.children}
    </TableCell>
  );
};

function DepositVerify({ handleClose, data, ...props }) {
  const [deposit_receive_datetime, setDeposit_receive_datetime] = useState("");
  const [selectedOperatingBank, setselectedOperatingBank] = useState('');
  const [verify, setVerify] = useState("0");
  const [comment, setComment] = useState("");
  const [agency_name, setagency_name] = useState('')
  const [deduction_from, setdeduction_from] = useState('')
  const [spinning, setSpinning] = useState(false);
  const [operatingBankList, setoperatingBankList] = useState(null);
  const [isAmountAdjusted, setisAmountAdjusted] = useState("0")
  const fetchOperatingBank = () => {
    getOperatingBankAccounts().then((res) => {
      if (res && res.success) {
        if (res.data.hasOwnProperty("operating_bank_accounts")) {
          let bankDetails = {};
          res.data["operating_bank_accounts"].map((bank) => {
            bankDetails[
              bank["operating_bank_account_id"]
            ] = `${bank["account_name"]} / ${bank["bank_name"]} / ${bank["ifsc_code"]}`;
            return bankDetails;
          });
          setoperatingBankList(bankDetails);
        }
      }
    });
  };
  useEffect(() => {
    fetchOperatingBank();
  }, []);
  const verifyDepositHandler = async (e) => {
    e.preventDefault();
    setSpinning(true);
    try {
      let formData = {};
      if (verify === null || verify === undefined) {
        setSpinning(false);
        return;
      }
      if (verify !== undefined) {
        formData["is_verified"] = Number(verify);
      }
      if (verify === "1") {
        if (deposit_receive_datetime) {
          formData["deposit_receive_datetime"] = format(
            new Date(deposit_receive_datetime),
            "yyyy-MM-dd HH:mm:ss"
          );
        }
        formData['is_amount_adjusted'] = Number(isAmountAdjusted);
        if (isAmountAdjusted === "1") {
          formData['agency_name'] = agency_name;
          formData['deduction_from'] = deduction_from;
        }
        if (selectedOperatingBank) {
          formData["operating_bank_account_id"] = selectedOperatingBank;

        }
      }
      if (comment) {
        formData["comment"] = comment;
      }
      formData["verified_by_subuser"] = props.user.subuser_reference_number;

      let res = await verifyDeposit(data["bank_deposit_reference_number"], {
        ...formData,
      });
      if (res.success) {
        toastSuccess(res.message);
        handleClose(false);
        window.location.reload();
      } else {
        toastWarning(res.message);
      }
      setSpinning(false);
    } catch (error) {
      setSpinning(false);
    }
  };

  return (
    <Spin spinning={spinning}>
      <DialogContent
        dividers={false}
        style={{
          backgroundColor: Colors["lighterPurple"],
          fontSize: "0.8125rem",
        }}
      >
        <Card>
          <CardContent>
            <TableContainer className="common_X_scroll">
              <Table size="small" aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TCell >Is Deposit Verified</TCell>
                    <TCell>
                      <KisstRadio
                        bigFont
                        values={{
                          1: "Yes",
                          0: "No",
                          2: "Cancel",
                        }}
                        name="payment_receipt_mode"
                        value={verify}
                        onChange={(e) => {
                          setVerify(e.target.value);
                        }}
                      />
                    </TCell>
                  </TableRow>
                </TableBody>

                {verify === "1" ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TCell >Is Salary Deducted / is Agency Invoice Adjusted</TCell>
                        <TCell>
                          <KisstRadio
                            bigFont
                            values={{
                              1: "Yes",
                              0: "No",
                            }}
                            name="is_amount_adjusted"
                            value={isAmountAdjusted}
                            onChange={(e) => {
                              setisAmountAdjusted(e.target.value);
                            }}
                          />
                        </TCell>
                      </TableRow>
                      {isAmountAdjusted === "1" && <><TableRow>
                        <TCell>Employee Id / Agency Name</TCell>
                        <TCell>
                          <CustomInput
                            style={{ width: "100%", border: '2px solid #ccc' }}
                            fullWidth
                            value={agency_name}
                            name="agency_name"
                            onChange={(e) => setagency_name(e.target.value)}
                            placeholder="Agency Name"
                          />
                        </TCell>
                      </TableRow>
                        <TableRow>
                          <TCell>Deduction From</TCell>
                          <TCell>
                            <CustomInput
                              style={{ width: "100%", border: '2px solid #ccc' }}
                              fullWidth
                              value={deduction_from}
                              name="deduction_from"
                              onChange={(e) => setdeduction_from(e.target.value)}
                              placeholder="Deduction From"
                            />
                          </TCell>
                        </TableRow></>}
                    </TableBody>
                  </>
                ) : null}

                {verify === "1" ? (
                  <TableBody>
                    <TableRow>
                      <TCell style={{ width: "30%" }}>Bank Deposit List</TCell>
                      <TCell>
                        <MNativeSelect
                          onChange={(e) => {
                            setselectedOperatingBank(e.target.value);
                          }}
                          nulloption={"Select Receiving Account"}
                          style={{ width: "100%" }}
                          value={selectedOperatingBank}
                          options={{ ...operatingBankList }}
                        />
                      </TCell>
                    </TableRow>
                  </TableBody>
                ) : null}
                {verify === "1" ? (
                  <TableBody>
                    <TableRow>
                      <TCell style={{ width: "30%" }}>Deposit Receive Time</TCell>
                      <TCell>
                        <CustomInput
                          required
                          InputProps={{
                            endAdornment: (
                              <InputAdornment>
                                <DateRangeIcon color="primary" />
                              </InputAdornment>
                            ),
                          }}
                          type="datetime-local"
                          textFieldStyle={{ width: "102%" }}
                          value={deposit_receive_datetime}
                          onChange={(e) =>
                            setDeposit_receive_datetime(e.target.value)
                          }
                        />
                      </TCell>
                    </TableRow>
                  </TableBody>
                ) : null}
                <TableBody>
                  <TableRow>
                    <TCell style={{ width: "30%" }}>Comment</TCell>
                    <TCell>
                      <TextareaAutosize style={{ border: '1px solid', width: '60%', padding: 8 }} name="comment"
                        onChange={(e) => setComment(e.target.value)}
                        value={comment}
                        aria-label="minimum height"
                        rowsMin={2}
                        rowsMax={4}
                        placeholder="Comment" />

                      {/* <InputField
                      name="comment"
                      value={comment}
                      touched={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Comment"
                      multiline={true}
                      rows={1}
                      rowsMax={3} >
                    </InputField> */}
                      {/* <CustomInput
                      style={{ width: "100%",border:'2px solid #ccc' }}
                      fullWidth
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Comment"
                      multiline={true}
                      rows={1}
                      rowsMax={3}
                    /> */}
                    </TCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={verifyDepositHandler}
          color="primary"
          variant="contained"
          className="shadow-none common_kissht_btn"
          type="submit"
          disabled={spinning}
        >
          Submit
        </Button>
        <Button
          onClick={() => handleClose(false)}
          variant="contained"
          className="shadow-none common_kissht_btn"
        //   disabled={spin || !isValid}
        >
          Close
        </Button>
      </DialogActions>
    </Spin>
  );
}
const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps, null)(DepositVerify);
